const PERMISSION_KEY= "crm:tag_user";
const PAGE_URL = {
    TAG_USER_PAGE: "/admin/crm/tag-user"
}

export {PERMISSION_KEY, PAGE_URL}

